import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.xl};
  }
`

export const PdfBox = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${space.md};
  padding: ${space.sm} ${space.lg};
  background-color: ${color.grayscale.white};
  border-radius: ${borders.radius.md};

  &:hover {
    text-decoration: none;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${space.xl3};
  padding-right: ${space.lg};
  margin-right: ${space.lg};
  border-right: ${borders.sizes.sm} solid ${color.grayscale.light};
`
